import { AuditCard } from "@/pages/a7/Audit/AuditCard";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Button, Link } from "@heroui/react";
import { useParams } from "react-router-dom";
import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";

import { EditCardWrapper } from "@/features/Edit/EditCardWrapper.tsx";
import { a7FIAIssuersEditForm } from "@/pages/a7/EditForms/a7FIAIssuersEditForm.tsx";
import { getIssuerAuditColumns } from "./columns";

const table_name = "a7_fia_issuers";

export const A7FIAIssuersEdit = () => {
  const { id } = useParams<{ id: string }>();
  const { t, i18n } = useTranslation();
  const auditColumns = useMemo(
    () => getIssuerAuditColumns(t),
    [t, i18n.language],
  );

  if (!id) {
    return <div>{t("errors.invalid_id")}</div>;
  }

  return (
    <div className="h-full bg-gray-50">
      <div className="flex flex-col gap-10 p-10">
        <div className="flex">
          <div className="flex-grow flex justify-center">
            <EditCardWrapper
              client={"a7"}
              id={Number(id)}
              headerText={t(`${table_name}.title`, {
                ns: "tables",
                defaultValue: "Issuer",
              })}
              {...a7FIAIssuersEditForm}
              disable_translations_request={true}
            />
          </div>
          <div className="flex flex-col gap-2">
            <Button
              href={toWorkspacePath(
                `/admin/a7-fia/a7_fia_instruments?issuer_id_equals=${id}`,
              )}
              variant="bordered"
              color="primary"
              showAnchorIcon
              as={Link}
              radius="full"
              className="bg-white border-1 border-neutral-300 shadow-xl"
            >
              {t("a7_fia_instruments.title", {
                ns: "tables",
                defaultValue: "Financial instruments",
              })}
            </Button>
            <Button
              href={toWorkspacePath(
                `/admin/a7-fia/a7_fia_issuer_ts?issuer_id_equals=${id}`,
              )}
              variant="bordered"
              color="primary"
              showAnchorIcon
              as={Link}
              radius="full"
              className="bg-white border-1 border-neutral-300 shadow-xl"
            >
              {t("a7_fia_issuer_ts.title", {
                ns: "tables",
                defaultValue: "Issuer time series",
              })}
            </Button>
          </div>
        </div>
        <AuditCard
          client={"a7"}
          id={Number(id)}
          name={table_name}
          audit_columns={auditColumns}
        />
      </div>
    </div>
  );
};
